import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next"; // I18N
// import abut3 from "../../images/about/img-3.jpg"
import abut3 from "../../images/about/img-3 (2).jpg";
import abutShape3 from "../../images/about/shape-2.png";
import VideoModal from "../ModalVideo/VideoModal";

const ClickHandler = () => {
  window.scrollTo(10, 0);
};

const AboutSection3 = () => {
  const { t } = useTranslation(); // I18N
  return (
    <section className="wpo-about-section-s3 ">
      <div className="container ">
        <div className="wpo-about-wrap">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-12 col-12">
              <div className="wpo-about-img-s3 p-lg-5">
                <VideoModal />
                <div className="image ">
                  <img src={abut3} alt="" />

                  <div className="shape">
                    <img src={abutShape3} alt="" />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-12">
              <div className="wpo-about-text">
                <div className="wpo-section-title">
                  <span>{t("home.about.welcome")}</span>
                  <h2>{t("home.about.title")}</h2>
                </div>
                {/* <p>Sokaab is the first Somali crowdfunding platform, dedicated to enabling communities and organizations to raise funds for meaningful projects. Our platform connects donors with changemakers, helping dreams become reality and communities to thrive.</p> */}
                <p>{t("home.about.description")}</p>
                <div className="about-btn">
                  <Link
                    to="/about"
                    className="theme-btn"
                    onClick={ClickHandler}
                  >
                    {t("home.about.discoverMore")}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection3;
